
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12419',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12419",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.473",
  "data-fetching-client": "static-1.9712",
  "foundations-components": "static-1.8021",
  "foundations-components-legacy": "static-1.1046",
  "foundations-theming": "static-1.4466",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8062",
  "hub-http-shared-msw-handlers": "static-1.10076",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11520",
  "I18n": "static-7.1633",
  "jasmine-runner": "static-1.6511",
  "marketplace-storefront-base": "static-1.12480",
  "quartz": "static-1.7089",
  "react-dlb": "static-1.79",
  "react-rhumb": "static-1.16723",
  "reactive-variable-buffer-atom": "static-1.2905",
  "reporting-testing-lib": "static-1.9693",
  "settings-ui-lib": "static-1.12566",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7223",
  "ui-addon-i18n": "static-1.11198",
  "ui-addon-react-router-dom": "static-1.9588",
  "unified-auth": "static-1.548",
  "unified-auth-core-lib": "static-1.830",
  "usage-tracker": "static-1.7396",
  "usage-tracker-core": "static-1.7246",
  "customer-data-property-utils": "static-1.8137",
  "hub-http": "static-1.6269",
  "integrations-lib": "static-1.16315",
  "marketplace-ui-common": "static-1.19935",
  "property-management-iframe": "static-1.13316",
  "quartz-config": "static-1.867",
  "quartz-core": "static-1.6308",
  "quartz-routing": "static-1.519",
  "quick-fetch": "static-1.3954",
  "react": "static-7.186",
  "rpc-client-utils": "static-1.4699",
  "ts-schema": "static-1.4117",
  "ui-universal-auth": "static-1.9034",
  "UIComponents": "static-3.8466",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3436",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3366",
  "quartz-webpack": "static-1.3313",
  "bend-plugin-quartz-routing": "static-1.167",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4290",
  "floating-ui": "static-1.57",
  "foundations-assets": "static-1.4916",
  "foundations-theming-specialty": "static-1.2182",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9470",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.31",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5381",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.488",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2065",
  "ui-fonts": "static-1.782",
  "ui-images": "static-2.1163",
  "bend-plugin-foundations-theming": "static-1.2949",
  "foundations-theming-base": "static-1.3451",
  "stylex": "static-1.34",
  "HeadJS": "static-2.765",
  "hs-test-utils-bend-plugin": "static-1.3173",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4372",
  "ai-components-ui-library": "static-1.9087",
  "ai-rendering-library": "static-1.10334",
  "chirp-fetch": "static-1.1934",
  "connections-embed-lib": "static-1.1070",
  "copilot-toolkit": "static-1.11257",
  "feedback-loader": "static-1.29381",
  "laboratory-lib": "static-3.7202",
  "marketplace-embed": "static-1.22229",
  "marketplace-ui-details": "static-1.9830",
  "marketplace-ui-reviews": "static-1.19890",
  "marketplace-ui-tracking": "static-1.14105",
  "sanitize-text": "static-1.8189",
  "ui-addon-video-player": "static-1.8750",
  "usage-tracker-multi": "static-1.5810",
  "usage-tracker-session-replay": "static-1.5082",
  "wootric-nps": "static-1.7019",
  "quartz-head": "static-1.754",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4698",
  "immer": "static-1.33",
  "immerable": "static-1.4200",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2520",
  "reporting-data": "static-1.67760",
  "cssUtils": "static-1.802",
  "flux-actions": "static-1.341",
  "HubStyle": "static-2.11827",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10255",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10411",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7386",
  "icons": "static-2.650",
  "marketplace-ui-apps-core": "static-1.18467",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4560",
  "foundations-components-test-utils": "static-1.5504",
  "quartz-i18n": "static-1.764",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.375",
  "microsoft-drive-integration-lib": "static-1.505",
  "slack-ui-library": "static-1.10438",
  "fsm": "static-1.3777",
  "customer-data-objects": "static-1.7722",
  "property-translator": "static-1.5445",
  "hs-locale-management": "static-1.117",
  "frontend-preferences-client": "static-1.7973",
  "hs-promise-utils": "static-1.5637",
  "hubspot-apollo-client": "static-1.4925",
  "integrations-error-boundary-lib": "static-1.13730",
  "integrations-tracking-lib": "static-1.5649",
  "native-integrations-shared-strings": "static-1.7828",
  "reselect": "static-2.16",
  "sanitize": "static-1.4522",
  "superstore": "static-1.4806",
  "ui-shepherd-react": "static-3.10252",
  "ai-settings-ui-library": "static-1.7955",
  "hub-http-janus": "static-1.839",
  "hubspotter-http": "static-1.4688",
  "immutable-less": "static-1.4699",
  "marketplace-ui-client-types": "static-1.17342",
  "nav-meta": "static-1.29795",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10293",
  "ui-addon-upgrades": "static-9.18062",
  "inbound-db-properties-service-client": "static-1.3883",
  "property-management-common": "static-1.5604",
  "ui-addon-iframeable": "static-1.9106",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.539",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.764",
  "quartz-test": "static-1.764",
  "quartz-tracking": "static-1.468",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.109",
  "bender-build-tools": "static-1.3227",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21490",
  "ContentUtils": "static-1.68503",
  "customer-data-objects-ui-components": "static-1.13077",
  "sassPrefix": "static-1.157",
  "breeze-engine-core": "static-1.94",
  "breeze-onboarding-components": "static-1.127",
  "avatar-components": "static-1.2545",
  "customer-data-filters-ui": "static-1.39964",
  "customer-data-reference-ui-components": "static-1.13215",
  "embedded-academy-lib": "static-1.14490",
  "ExportDialog": "static-6.10432",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41430",
  "reporting-snowflake": "static-1.56378",
  "reporting-ui-components": "static-2.65031",
  "reporting-visualizations": "static-1.59836",
  "ui-addon-teams": "static-1.21619",
  "magpie-lib": "static-1.5581",
  "navigation-components": "static-1.18158",
  "breeze-engine-lib": "static-1.816",
  "magpie-types": "static-1.5041",
  "simple-logging-lib": "static-1.3097",
  "ai-studio-lib": "static-1.11750",
  "app-governance-lib": "static-1.1703",
  "developer-experience-shared-components": "static-1.10558",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8046",
  "ui-product-approvals": "static-1.28285",
  "ui-tool-access": "static-1.10194",
  "usage-based-billing-components-lib": "static-1.9149",
  "usage-tracker-anonymous": "static-1.5813",
  "usage-tracker-public": "static-1.7207",
  "amplitude-session-replay-browser": "static-1.63",
  "inbound-db-meta-service-client": "static-1.3623",
  "persist-promise": "static-1.3746",
  "reference-resolvers": "static-1.8218",
  "ui-extensibility-client-types": "static-1.3971",
  "hubspot-apollo-cache": "static-1.384",
  "universal-page-editor-lib": "static-1.3062",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2910",
  "merchandise-lib": "static-1.265",
  "atom": "static-1.5121",
  "purchase-motions-components": "static-1.5998",
  "salesImages": "static-1.526",
  "batch-promise": "static-1.1589",
  "crm-component-utils": "static-1.39203",
  "crm-properties-common-lib": "static-1.5933",
  "customer-data-properties": "static-1.51733",
  "framework-data-schema-resolvers": "static-1.6934",
  "property-value-citations": "static-1.2347",
  "reference-resolvers-lite": "static-1.8142",
  "ui-business-units-lib": "static-1.9105",
  "navigation-messaging": "static-1.7485",
  "hubspotter-http-shared-msw-handlers": "static-1.10074",
  "cms-field-types": "static-1.4859",
  "content-icons-ui": "static-1.2237",
  "customer-data-ui-utilities": "static-1.9872",
  "events-data-lib": "static-1.273",
  "conversations-skeleton-state": "static-1.7295",
  "crm-message-bus": "static-1.43093",
  "customer-data-filters-ui-msw-helpers": "static-1.22399",
  "FormUrlGenerator": "static-2.4767",
  "framework-builder-read-service-client": "static-1.4041",
  "framework-data-schema-quick-fetch": "static-1.6839",
  "multi-account-reference-resolvers": "static-1.1028",
  "onboarding-tours": "static-1.16693",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13813",
  "academy-common-lib": "static-1.13950",
  "content-assistance-lib": "static-1.7822",
  "dashboard-lib": "static-1.81712",
  "file-manager-components": "static-1.23745",
  "getting-started-shared-tasks": "static-1.18560",
  "hubspot-prosemirror": "static-1.18362",
  "hubspot-prosemirror-plugins": "static-1.18354",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19910",
  "share-with-third-party-component-lib": "static-1.8751",
  "ui-addon-draggable": "static-3.4809",
  "ui-asset-management-lib": "static-1.11098",
  "user-context": "static-1.5153",
  "growth-payments-core": "static-1.25514",
  "reporting-plugins": "static-1.10393",
  "reporting-reports": "static-1.67438",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.770",
  "nest": "static-1.278",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10674",
  "framework-listing-lib": "static-2.28818",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30831",
  "apps-service-types": "static-1.3910",
  "oauth-service-types": "static-1.4297",
  "ui-product-approvals-common": "static-1.180",
  "onboarding-scopes": "static-1.6508",
  "onboarding-tours-client": "static-1.4907",
  "platform-infra-nav-components": "static-1.7708",
  "subscription-experience-data-types": "static-1.14995",
  "crm-record-cards-service-types": "static-1.3627",
  "location-customization-utils-lib": "static-1.9398",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6001",
  "signup-constants": "static-1.18939",
  "signup-ui-url-generator": "static-2.8101",
  "card-properties-lib": "static-1.44338",
  "commerce-subscription-lib": "static-1.37256",
  "crm-actions": "static-1.6382",
  "crm-cards-sdk": "static-1.43728",
  "customer-data-properties-shared-msw-handlers": "static-1.9403",
  "customer-data-tracking": "static-1.6936",
  "hs-resources": "static-1.212",
  "pulse": "static-1.630",
  "calling-global-api": "static-1.64674",
  "calling-internal-common": "static-1.31351",
  "calling-lifecycle-internal": "static-1.66056",
  "calling-lifecycle-messages": "static-1.58350",
  "commerce-products-lib": "static-1.9737",
  "conditional-properties-service-client": "static-1.3834",
  "crm-links": "static-1.6350",
  "crm-pipelines-api-client-types": "static-1.4177",
  "external-options-client-types": "static-1.4196",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4260",
  "meetings-icalendar-utils-lib": "static-1.678",
  "multi-currency-client-types": "static-1.3729",
  "object-builder-ui-client": "static-1.48904",
  "pipeline-validation-client-types": "static-1.4003",
  "smart-property-lib": "static-1.7341",
  "tiered-pricing": "static-1.1321",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11036",
  "fdsr-migration-layer": "static-1.53",
  "react-dnd-compat": "static-1.4660",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1032",
  "growth-data-modal": "static-1.5500",
  "growth-onboarding-confetti": "static-1.3113",
  "growth-onboarding-next-action-utils": "static-1.2056",
  "onboarding-tours-utils": "static-1.759",
  "ui-shepherd-tracker": "static-1.7633",
  "academy-service-client": "static-1.3729",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39244",
  "FileManagerLib": "static-1.39385",
  "video-embed": "static-1.35938",
  "ui-coaching-tips": "static-1.28692",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11446",
  "video-data-lib": "static-1.35104",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8511",
  "payment-link-components": "static-1.23637",
  "ui-addon-emoji-picker": "static-1.9933",
  "EmailSignatureEditor": "static-1.24476",
  "viral-links-lib": "static-1.7114",
  "data-token-picker": "static-1.16485",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.273",
  "timezone-utils": "static-2.5290",
  "seat-types-lib": "static-1.125",
  "getting-started-shared-tasks-store": "static-1.17678",
  "ui-addon-opt": "static-4.8409",
  "campaign-roi-lib": "static-1.9256",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25554",
  "framework-data-table": "static-2.12023",
  "marketing-platform-lib": "static-1.6906",
  "nudge-client-utils": "static-1.2684",
  "nudge-custom-ui-functions": "static-1.1116",
  "switchboard-lib": "static-1.266",
  "app-users-service-client": "static-1.5646",
  "app-users-service-types": "static-1.5054",
  "mini-checkout-client": "static-1.26922",
  "onboarding-utils": "static-1.5404",
  "permissions-shared-i18n-strings-fe": "static-1.2050",
  "ui-coaching-tips-shared-config": "static-1.28677",
  "edison-service-client-types": "static-1.435",
  "crm_data": "static-4.92112",
  "customer-data-sidebar": "static-2.46147",
  "enrichment-properties-lib": "static-1.16459",
  "ui-addon-draggable-compat": "static-2.4305",
  "commerce-billing-lib": "static-1.19224",
  "commerce-shared-components-lib": "static-1.18648",
  "commerce-tools-ui-lib": "static-1.10502",
  "crm-fe-perf": "static-1.22949",
  "event-emitter": "static-1.994",
  "bend-plugin-pulse": "static-1.133",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31358",
  "shared-worker-versioning": "static-1.11082",
  "calling-usage-tracker": "static-1.6588",
  "voice-sms-access-library": "static-1.1192",
  "commerce-permissions": "static-1.820",
  "products-iframe-lib": "static-1.8067",
  "products-ui-components-shared-msw-handlers": "static-1.10458",
  "data-agent-kit": "static-1.266",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10159",
  "policy-lib": "static-1.6823",
  "react-tinymce": "static-1.55375",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10222",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54501",
  "tinymce-plugins": "static-1.57615",
  "tinymce-themes": "static-1.56471",
  "onboarding-data-sync-lib": "static-1.2030",
  "growth-onboarding-next-action-components": "static-1.2084",
  "user-context-client": "static-1.4655",
  "audio-components": "static-1.5984",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36896",
  "urlinator": "static-1.4584",
  "video-components": "static-1.13448",
  "outpost": "static-1.4223",
  "growth-onboarding-feedback-components": "static-1.6626",
  "content-media-composition-data-lib": "static-1.12500",
  "content-media-compositions": "static-2.16507",
  "media-bridge-lib": "static-1.19006",
  "commerce-tours-lib": "static-1.6188",
  "growth-onboarding-reliability": "static-1.5127",
  "sales-checkout-service-client": "static-1.3688",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21755",
  "sales-email-signature-service-client": "static-1.3893",
  "ts-utils-lib": "static-1.218",
  "crm-export-dialog": "static-1.6337",
  "crm-index-associations-lib": "static-1.6487",
  "crm-view-components": "static-1.412",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7374",
  "tanstack-virtual": "static-1.31",
  "nudge-custom-function-registry": "static-1.2441",
  "nudge-renderer-utils": "static-1.2760",
  "whisper-core-api": "static-1.6758",
  "InboxConnectUtils": "static-4.14943",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5657",
  "settings-content-modals": "static-1.46220",
  "crm_universal": "static-1.22086",
  "customer-data-email": "static-1.18114",
  "card-payment-highlight-lib": "static-1.37308",
  "card-subscription-highlight-lib": "static-1.39679",
  "commerce-contract-lib": "static-1.12254",
  "invoices-highlight-card-lib": "static-1.54867",
  "orders-highlight-card-lib": "static-1.21597",
  "products-highlight-card-lib": "static-1.18020",
  "quotes-highlight-card-lib": "static-1.72197",
  "crm-source-interpretation-lib": "static-1.5390",
  "utility-belt": "static-1.2580",
  "payments-enrollment-embed-lib": "static-1.23030",
  "stripe-embedded-components": "static-1.7586",
  "customer-data-rte": "static-1.33123",
  "cv-backend-services": "static-1.1555",
  "growth-onboarding-empty-states": "static-1.5821",
  "payments-post-enroll-local-storage-lib": "static-1.5155",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38287",
  "trials-service-types": "static-1.3952",
  "calling-orchestration-schema": "static-1.35969",
  "sales-views-client-types": "static-1.4304",
  "hub-http-contrib": "static-1.3088",
  "interframe": "static-3.4805",
  "tinymce-data": "static-1.40586",
  "ui-addon-sales-email": "static-1.5257",
  "layout-dnd-components": "static-1.12531",
  "layout-dnd-utils": "static-1.11506",
  "ui-brand-identity-lib": "static-1.15465",
  "NamespacedHubStyle": "static-2.9095",
  "meetings-connect-utils-lib": "static-1.7651",
  "social-insights-client-types": "static-1.22231",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4203",
  "checkout-sdk": "static-3.23765",
  "checkout-service-types": "static-1.3846",
  "company-details-components": "static-1.6242",
  "payment-method-components": "static-1.6942",
  "pricing-pages-ui-components": "static-1.14253",
  "quote-checkout-service-types": "static-1.3513",
  "upgrade-catalog-service-types": "static-1.3568",
  "access-control-lib": "static-1.10481",
  "EmailComponents": "static-1.54889",
  "EmailData": "static-1.53566",
  "redux-less": "static-2.9530",
  "sequences-lib": "static-1.8122",
  "ui-gdpr-components": "static-1.10396",
  "products-ui-components": "static-1.40255",
  "accounting-integrations-ui-components": "static-1.7135",
  "invoices-ui-lib": "static-1.54883",
  "commerce-products-api": "static-1.2367",
  "invoices-iframe-lib": "static-1.56941",
  "quotes-modal-lib": "static-1.102875",
  "quotes-ui-lib": "static-1.80918",
  "stripe-connect-js": "static-1.69",
  "draft-content-plugins": "static-1.28395",
  "ContentData": "static-1.68578",
  "layout-data-lib": "static-1.9831",
  "hub-http-rxjs": "static-1.805",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3986",
  "billing-payments-client-types": "static-1.4038",
  "react-performance-metrics-lib": "static-1.603",
  "account-and-billing-fintech-outages": "static-3.18649",
  "pricing-pages-api": "static-1.14118",
  "ContentComponents": "static-2.71459",
  "marketing-contacts-lib": "static-1.10208",
  "marketing-email-service-types": "static-1.1938",
  "messaging-editing-lib": "static-1.46409",
  "messaging-usage-based-billing-components-lib": "static-1.1271",
  "automation-ui-source-apps": "static-1.19015",
  "automation-ui-types": "static-1.19933",
  "messaging-types-lib": "static-1.46146",
  "onboarding-settings-client": "static-1.4551",
  "sequences-client-types-lib": "static-1.7979",
  "commerce-tax-lib": "static-1.576",
  "price-books-api": "static-1.983",
  "price-books-components": "static-1.1041",
  "property-description-translator": "static-1.3889",
  "ramp-editor": "static-1.255",
  "commerce-analytics-service-client": "static-1.3676",
  "totals-ui-components": "static-1.23738",
  "SalesContentIndexUI": "static-3.9318",
  "advanced-menus-core": "static-1.15200",
  "advanced-menus-lib": "static-1.12137",
  "ui-memberships-settings-lib": "static-1.34175",
  "segments-query-core": "static-1.1464",
  "eligibility-engine-service-types": "static-1.3233",
  "automation-ui-ubb": "static-1.5849",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7385",
  "data-token-views": "static-1.16466",
  "forms-utils-lib": "static-1.12670",
  "payments-embed-points-lib": "static-1.13132",
  "simple-menus-core": "static-1.15199",
  "simple-menus-lib": "static-1.16716",
  "videoconference-integration-components": "static-1.6890",
  "marketing-contacts-client": "static-1.7562",
  "automation-applications-service-types": "static-1.3553",
  "automation-platform-service-types": "static-1.2603",
  "ContentEditorUI": "static-2.77232",
  "short-messages-app-service-client": "static-1.4016",
  "web-interactives-components": "static-1.13838",
  "web-interactives-data": "static-1.13839",
  "messaging-shared-utils-lib": "static-1.720",
  "messaging-user-info-utils-lib": "static-1.890",
  "email-portal-health-service-types": "static-1.1025",
  "line-items-api": "static-1.767",
  "commerce-totals-service-types": "static-1.3856",
  "FireAlarmUi": "static-1.4549",
  "sales-templates-service-types-lib": "static-1.4206",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21869",
  "automation-ui-usage-tracking": "static-1.21332",
  "data-studio-ubb": "static-1.2857",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27143",
  "collaboration-sidebar": "static-1.57947",
  "content-management-data-lib": "static-1.5446",
  "copilot-plugins": "static-1.11230",
  "cta-picker": "static-1.36533",
  "customer-agent-discovery-components-lib": "static-1.3224",
  "editor-components": "static-1.13299",
  "editor-iframe-lib": "static-1.8470",
  "error-messaging-js": "static-1.5239",
  "FormsCommonComponents": "static-1.85981",
  "pictos": "static-7.185",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10692",
  "SharedLegalStrings": "static-1.1794",
  "smart-content-core": "static-1.42575",
  "smart-content-lib": "static-1.43228",
  "social-composer-lib": "static-1.59341",
  "structured-content-lib": "static-1.25321",
  "theme-previewer-lib": "static-1.53368",
  "tinymce-copilot": "static-1.16569",
  "xray-recommendation-lib": "static-1.7970",
  "automation-ui-routing": "static-1.21290",
  "sql-reporting-client-types": "static-1.5673",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42296",
  "campaigns-utils-lib": "static-1.3232",
  "reporting-enablement": "static-1.23090",
  "chatspot-widget-iframe": "static-1.21481",
  "collaboration-sidebar-common": "static-1.2744",
  "forms-ai-lib": "static-1.4388",
  "codemirror-dlb": "static-1.58791",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6479",
  "report-customization-components": "static-1.13301",
  "data-quality-ui-library": "static-1.13169",
  "html-to-image": "static-1.55",
  "reporting-filters": "static-1.448",
  "reporting-insights-lib": "static-1.1883"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12419",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.473",
  "data-fetching-client": "/data-fetching-client/static-1.9712",
  "foundations-components": "/foundations-components/static-1.8021",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1046",
  "foundations-theming": "/foundations-theming/static-1.4466",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8062",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10076",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11520",
  "I18n": "/I18n/static-7.1633",
  "jasmine-runner": "/jasmine-runner/static-1.6511",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12480",
  "quartz": "/quartz/static-1.7089",
  "react-dlb": "/react-dlb/static-1.79",
  "react-rhumb": "/react-rhumb/static-1.16723",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2905",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9693",
  "settings-ui-lib": "/settings-ui-lib/static-1.12566",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7223",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11198",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9588",
  "unified-auth": "/unified-auth/static-1.548",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.830",
  "usage-tracker": "/usage-tracker/static-1.7396",
  "usage-tracker-core": "/usage-tracker-core/static-1.7246",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8137",
  "hub-http": "/hub-http/static-1.6269",
  "integrations-lib": "/integrations-lib/static-1.16315",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19935",
  "property-management-iframe": "/property-management-iframe/static-1.13316",
  "quartz-config": "/quartz-config/static-1.867",
  "quartz-core": "/quartz-core/static-1.6308",
  "quartz-routing": "/quartz-routing/static-1.519",
  "quick-fetch": "/quick-fetch/static-1.3954",
  "react": "/react/static-7.186",
  "rpc-client-utils": "/rpc-client-utils/static-1.4699",
  "ts-schema": "/ts-schema/static-1.4117",
  "ui-universal-auth": "/ui-universal-auth/static-1.9034",
  "UIComponents": "/UIComponents/static-3.8466",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3436",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3366",
  "quartz-webpack": "/quartz-webpack/static-1.3313",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.167",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4290",
  "floating-ui": "/floating-ui/static-1.57",
  "foundations-assets": "/foundations-assets/static-1.4916",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2182",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9470",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.31",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5381",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2065",
  "ui-fonts": "/ui-fonts/static-1.782",
  "ui-images": "/ui-images/static-2.1163",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2949",
  "foundations-theming-base": "/foundations-theming-base/static-1.3451",
  "stylex": "/stylex/static-1.34",
  "HeadJS": "/HeadJS/static-2.765",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3173",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4372",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9087",
  "ai-rendering-library": "/ai-rendering-library/static-1.10334",
  "chirp-fetch": "/chirp-fetch/static-1.1934",
  "connections-embed-lib": "/connections-embed-lib/static-1.1070",
  "copilot-toolkit": "/copilot-toolkit/static-1.11257",
  "feedback-loader": "/feedback-loader/static-1.29381",
  "laboratory-lib": "/laboratory-lib/static-3.7202",
  "marketplace-embed": "/marketplace-embed/static-1.22229",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9830",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19890",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14105",
  "sanitize-text": "/sanitize-text/static-1.8189",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8750",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5810",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5082",
  "wootric-nps": "/wootric-nps/static-1.7019",
  "quartz-head": "/quartz-head/static-1.754",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4698",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4200",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2520",
  "reporting-data": "/reporting-data/static-1.67760",
  "cssUtils": "/cssUtils/static-1.802",
  "flux-actions": "/flux-actions/static-1.341",
  "HubStyle": "/HubStyle/static-2.11827",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10255",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10411",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7386",
  "icons": "/icons/static-2.650",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18467",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4560",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5504",
  "quartz-i18n": "/quartz-i18n/static-1.764",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.375",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.505",
  "slack-ui-library": "/slack-ui-library/static-1.10438",
  "fsm": "/fsm/static-1.3777",
  "customer-data-objects": "/customer-data-objects/static-1.7722",
  "property-translator": "/property-translator/static-1.5445",
  "hs-locale-management": "/hs-locale-management/static-1.117",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7973",
  "hs-promise-utils": "/hs-promise-utils/static-1.5637",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4925",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13730",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5649",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7828",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4522",
  "superstore": "/superstore/static-1.4806",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10252",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7955",
  "hub-http-janus": "/hub-http-janus/static-1.839",
  "hubspotter-http": "/hubspotter-http/static-1.4688",
  "immutable-less": "/immutable-less/static-1.4699",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17342",
  "nav-meta": "/nav-meta/static-1.29795",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10293",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18062",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3883",
  "property-management-common": "/property-management-common/static-1.5604",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9106",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.764",
  "quartz-test": "/quartz-test/static-1.764",
  "quartz-tracking": "/quartz-tracking/static-1.468",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.109",
  "bender-build-tools": "/bender-build-tools/static-1.3227",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21490",
  "ContentUtils": "/ContentUtils/static-1.68503",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13077",
  "sassPrefix": "/sassPrefix/static-1.157",
  "breeze-engine-core": "/breeze-engine-core/static-1.94",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.127",
  "avatar-components": "/avatar-components/static-1.2545",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39964",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13215",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14490",
  "ExportDialog": "/ExportDialog/static-6.10432",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41430",
  "reporting-snowflake": "/reporting-snowflake/static-1.56378",
  "reporting-ui-components": "/reporting-ui-components/static-2.65031",
  "reporting-visualizations": "/reporting-visualizations/static-1.59836",
  "ui-addon-teams": "/ui-addon-teams/static-1.21619",
  "magpie-lib": "/magpie-lib/static-1.5581",
  "navigation-components": "/navigation-components/static-1.18158",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.816",
  "magpie-types": "/magpie-types/static-1.5041",
  "simple-logging-lib": "/simple-logging-lib/static-1.3097",
  "ai-studio-lib": "/ai-studio-lib/static-1.11750",
  "app-governance-lib": "/app-governance-lib/static-1.1703",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10558",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8046",
  "ui-product-approvals": "/ui-product-approvals/static-1.28285",
  "ui-tool-access": "/ui-tool-access/static-1.10194",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9149",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5813",
  "usage-tracker-public": "/usage-tracker-public/static-1.7207",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.63",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3623",
  "persist-promise": "/persist-promise/static-1.3746",
  "reference-resolvers": "/reference-resolvers/static-1.8218",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3971",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.384",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3062",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2910",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "atom": "/atom/static-1.5121",
  "purchase-motions-components": "/purchase-motions-components/static-1.5998",
  "salesImages": "/salesImages/static-1.526",
  "batch-promise": "/batch-promise/static-1.1589",
  "crm-component-utils": "/crm-component-utils/static-1.39203",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5933",
  "customer-data-properties": "/customer-data-properties/static-1.51733",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6934",
  "property-value-citations": "/property-value-citations/static-1.2347",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8142",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9105",
  "navigation-messaging": "/navigation-messaging/static-1.7485",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10074",
  "cms-field-types": "/cms-field-types/static-1.4859",
  "content-icons-ui": "/content-icons-ui/static-1.2237",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9872",
  "events-data-lib": "/events-data-lib/static-1.273",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7295",
  "crm-message-bus": "/crm-message-bus/static-1.43093",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22399",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4767",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4041",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6839",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1028",
  "onboarding-tours": "/onboarding-tours/static-1.16693",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13813",
  "academy-common-lib": "/academy-common-lib/static-1.13950",
  "content-assistance-lib": "/content-assistance-lib/static-1.7822",
  "dashboard-lib": "/dashboard-lib/static-1.81712",
  "file-manager-components": "/file-manager-components/static-1.23745",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18560",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18362",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18354",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19910",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8751",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4809",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11098",
  "user-context": "/user-context/static-1.5153",
  "growth-payments-core": "/growth-payments-core/static-1.25514",
  "reporting-plugins": "/reporting-plugins/static-1.10393",
  "reporting-reports": "/reporting-reports/static-1.67438",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.770",
  "nest": "/nest/static-1.278",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10674",
  "framework-listing-lib": "/framework-listing-lib/static-2.28818",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30831",
  "apps-service-types": "/apps-service-types/static-1.3910",
  "oauth-service-types": "/oauth-service-types/static-1.4297",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.180",
  "onboarding-scopes": "/onboarding-scopes/static-1.6508",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4907",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7708",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14995",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3627",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9398",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6001",
  "signup-constants": "/signup-constants/static-1.18939",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8101",
  "card-properties-lib": "/card-properties-lib/static-1.44338",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37256",
  "crm-actions": "/crm-actions/static-1.6382",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43728",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9403",
  "customer-data-tracking": "/customer-data-tracking/static-1.6936",
  "hs-resources": "/hs-resources/static-1.212",
  "pulse": "/pulse/static-1.630",
  "calling-global-api": "/calling-global-api/static-1.64674",
  "calling-internal-common": "/calling-internal-common/static-1.31351",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66056",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58350",
  "commerce-products-lib": "/commerce-products-lib/static-1.9737",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3834",
  "crm-links": "/crm-links/static-1.6350",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4177",
  "external-options-client-types": "/external-options-client-types/static-1.4196",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4260",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.678",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3729",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48904",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4003",
  "smart-property-lib": "/smart-property-lib/static-1.7341",
  "tiered-pricing": "/tiered-pricing/static-1.1321",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11036",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.53",
  "react-dnd-compat": "/react-dnd-compat/static-1.4660",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1032",
  "growth-data-modal": "/growth-data-modal/static-1.5500",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3113",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2056",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.759",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7633",
  "academy-service-client": "/academy-service-client/static-1.3729",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39244",
  "FileManagerLib": "/FileManagerLib/static-1.39385",
  "video-embed": "/video-embed/static-1.35938",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28692",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11446",
  "video-data-lib": "/video-data-lib/static-1.35104",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8511",
  "payment-link-components": "/payment-link-components/static-1.23637",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9933",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24476",
  "viral-links-lib": "/viral-links-lib/static-1.7114",
  "data-token-picker": "/data-token-picker/static-1.16485",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.273",
  "timezone-utils": "/timezone-utils/static-2.5290",
  "seat-types-lib": "/seat-types-lib/static-1.125",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17678",
  "ui-addon-opt": "/ui-addon-opt/static-4.8409",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9256",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25554",
  "framework-data-table": "/framework-data-table/static-2.12023",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6906",
  "nudge-client-utils": "/nudge-client-utils/static-1.2684",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1116",
  "switchboard-lib": "/switchboard-lib/static-1.266",
  "app-users-service-client": "/app-users-service-client/static-1.5646",
  "app-users-service-types": "/app-users-service-types/static-1.5054",
  "mini-checkout-client": "/mini-checkout-client/static-1.26922",
  "onboarding-utils": "/onboarding-utils/static-1.5404",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2050",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28677",
  "edison-service-client-types": "/edison-service-client-types/static-1.435",
  "crm_data": "/crm_data/static-4.92112",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46147",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16459",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4305",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19224",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18648",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10502",
  "crm-fe-perf": "/crm-fe-perf/static-1.22949",
  "event-emitter": "/event-emitter/static-1.994",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.133",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31358",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11082",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6588",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1192",
  "commerce-permissions": "/commerce-permissions/static-1.820",
  "products-iframe-lib": "/products-iframe-lib/static-1.8067",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10458",
  "data-agent-kit": "/data-agent-kit/static-1.266",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10159",
  "policy-lib": "/policy-lib/static-1.6823",
  "react-tinymce": "/react-tinymce/static-1.55375",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10222",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54501",
  "tinymce-plugins": "/tinymce-plugins/static-1.57615",
  "tinymce-themes": "/tinymce-themes/static-1.56471",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2030",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2084",
  "user-context-client": "/user-context-client/static-1.4655",
  "audio-components": "/audio-components/static-1.5984",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36896",
  "urlinator": "/urlinator/static-1.4584",
  "video-components": "/video-components/static-1.13448",
  "outpost": "/outpost/static-1.4223",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6626",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12500",
  "content-media-compositions": "/content-media-compositions/static-2.16507",
  "media-bridge-lib": "/media-bridge-lib/static-1.19006",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6188",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5127",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3688",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21755",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3893",
  "ts-utils-lib": "/ts-utils-lib/static-1.218",
  "crm-export-dialog": "/crm-export-dialog/static-1.6337",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6487",
  "crm-view-components": "/crm-view-components/static-1.412",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7374",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2441",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2760",
  "whisper-core-api": "/whisper-core-api/static-1.6758",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14943",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5657",
  "settings-content-modals": "/settings-content-modals/static-1.46220",
  "crm_universal": "/crm_universal/static-1.22086",
  "customer-data-email": "/customer-data-email/static-1.18114",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37308",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39679",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12254",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54867",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21597",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18020",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72197",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5390",
  "utility-belt": "/utility-belt/static-1.2580",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23030",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7586",
  "customer-data-rte": "/customer-data-rte/static-1.33123",
  "cv-backend-services": "/cv-backend-services/static-1.1555",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5821",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5155",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38287",
  "trials-service-types": "/trials-service-types/static-1.3952",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35969",
  "sales-views-client-types": "/sales-views-client-types/static-1.4304",
  "hub-http-contrib": "/hub-http-contrib/static-1.3088",
  "interframe": "/interframe/static-3.4805",
  "tinymce-data": "/tinymce-data/static-1.40586",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5257",
  "layout-dnd-components": "/layout-dnd-components/static-1.12531",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11506",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15465",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9095",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7651",
  "social-insights-client-types": "/social-insights-client-types/static-1.22231",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4203",
  "checkout-sdk": "/checkout-sdk/static-3.23765",
  "checkout-service-types": "/checkout-service-types/static-1.3846",
  "company-details-components": "/company-details-components/static-1.6242",
  "payment-method-components": "/payment-method-components/static-1.6942",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14253",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3513",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3568",
  "access-control-lib": "/access-control-lib/static-1.10481",
  "EmailComponents": "/EmailComponents/static-1.54889",
  "EmailData": "/EmailData/static-1.53566",
  "redux-less": "/redux-less/static-2.9530",
  "sequences-lib": "/sequences-lib/static-1.8122",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10396",
  "products-ui-components": "/products-ui-components/static-1.40255",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7135",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54883",
  "commerce-products-api": "/commerce-products-api/static-1.2367",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56941",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102875",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80918",
  "stripe-connect-js": "/stripe-connect-js/static-1.69",
  "draft-content-plugins": "/draft-content-plugins/static-1.28395",
  "ContentData": "/ContentData/static-1.68578",
  "layout-data-lib": "/layout-data-lib/static-1.9831",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.805",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3986",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4038",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.603",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18649",
  "pricing-pages-api": "/pricing-pages-api/static-1.14118",
  "ContentComponents": "/ContentComponents/static-2.71459",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10208",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1938",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46409",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1271",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19015",
  "automation-ui-types": "/automation-ui-types/static-1.19933",
  "messaging-types-lib": "/messaging-types-lib/static-1.46146",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4551",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7979",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.576",
  "price-books-api": "/price-books-api/static-1.983",
  "price-books-components": "/price-books-components/static-1.1041",
  "property-description-translator": "/property-description-translator/static-1.3889",
  "ramp-editor": "/ramp-editor/static-1.255",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3676",
  "totals-ui-components": "/totals-ui-components/static-1.23738",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9318",
  "advanced-menus-core": "/advanced-menus-core/static-1.15200",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12137",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34175",
  "segments-query-core": "/segments-query-core/static-1.1464",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3233",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5849",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7385",
  "data-token-views": "/data-token-views/static-1.16466",
  "forms-utils-lib": "/forms-utils-lib/static-1.12670",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13132",
  "simple-menus-core": "/simple-menus-core/static-1.15199",
  "simple-menus-lib": "/simple-menus-lib/static-1.16716",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6890",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7562",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3553",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2603",
  "ContentEditorUI": "/ContentEditorUI/static-2.77232",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4016",
  "web-interactives-components": "/web-interactives-components/static-1.13838",
  "web-interactives-data": "/web-interactives-data/static-1.13839",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.720",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.890",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1025",
  "line-items-api": "/line-items-api/static-1.767",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3856",
  "FireAlarmUi": "/FireAlarmUi/static-1.4549",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4206",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21869",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21332",
  "data-studio-ubb": "/data-studio-ubb/static-1.2857",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27143",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57947",
  "content-management-data-lib": "/content-management-data-lib/static-1.5446",
  "copilot-plugins": "/copilot-plugins/static-1.11230",
  "cta-picker": "/cta-picker/static-1.36533",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3224",
  "editor-components": "/editor-components/static-1.13299",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8470",
  "error-messaging-js": "/error-messaging-js/static-1.5239",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85981",
  "pictos": "/pictos/static-7.185",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10692",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1794",
  "smart-content-core": "/smart-content-core/static-1.42575",
  "smart-content-lib": "/smart-content-lib/static-1.43228",
  "social-composer-lib": "/social-composer-lib/static-1.59341",
  "structured-content-lib": "/structured-content-lib/static-1.25321",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53368",
  "tinymce-copilot": "/tinymce-copilot/static-1.16569",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7970",
  "automation-ui-routing": "/automation-ui-routing/static-1.21290",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5673",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42296",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3232",
  "reporting-enablement": "/reporting-enablement/static-1.23090",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21481",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2744",
  "forms-ai-lib": "/forms-ai-lib/static-1.4388",
  "codemirror-dlb": "/codemirror-dlb/static-1.58791",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6479",
  "report-customization-components": "/report-customization-components/static-1.13301",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13169",
  "html-to-image": "/html-to-image/static-1.55",
  "reporting-filters": "/reporting-filters/static-1.448",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1883"
}
};
